var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 56,
    viewBox: "0 0 66 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49.7071 28.7094C50.0976 28.3189 50.0976 27.6857 49.7071 27.2952L43.3431 20.9312C42.9526 20.5407 42.3195 20.5407 41.9289 20.9312C41.5384 21.3218 41.5384 21.9549 41.9289 22.3455L47.5858 28.0023L41.9289 33.6592C41.5384 34.0497 41.5384 34.6829 41.9289 35.0734C42.3195 35.4639 42.9526 35.4639 43.3431 35.0734L49.7071 28.7094ZM36.5553 11L21.9986 11.0034L21.9991 13.0034L36.5558 13L36.5553 11ZM16 17.0034V38.9988H18V17.0034H16ZM22.0014 44.9988L36.5558 44.9954L36.5553 42.9954L22.0009 42.9988L22.0014 44.9988ZM27.6667 29.0023H38.3333V27.0023H27.6667V29.0023ZM38.3333 29.0023H49V27.0023H38.3333V29.0023ZM16 38.9988C16 42.3131 18.6872 44.9996 22.0014 44.9988L22.0009 42.9988C19.7914 42.9993 18 41.2083 18 38.9988H16ZM21.9986 11.0034C18.6854 11.0042 16 13.6903 16 17.0034H18C18 14.7947 19.7903 13.004 21.9991 13.0034L21.9986 11.0034Z",
    fill: "#4F5B6F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.6f3f8004a63139a224d68081aa1848b4.svg";
export { ForwardRef as ReactComponent };